import { useLogout } from '../../api/hooks/useAuth'
import styles from '../../styles/admin/SignInHeader.module.scss'
import BaseButton from '../common/BaseButton'
import { useNavigate, useLocation } from 'react-router-dom'
import { Icon } from '../../assets/icons'
import { useAuthStore } from '../../store'

const SignInHeader = () => {
  const logout = useLogout()
  const navigate = useNavigate()
  const location = useLocation()
  const { isLoggedIn, user } = useAuthStore()

  const handleLogout = () => {
    logout()
  }

  const handleMyPage = () => {
    if (isLoggedIn) {
      navigate('/dashboard/individual')
    } else {
      navigate('/signin')
    }
  }

  const showButtonPaths = ['/solver']
  const shouldShowButton = showButtonPaths.includes(location.pathname)

  return (
    <div className={styles.signInHeaderContainer}>
      <button onClick={handleMyPage} className={styles.signInHeaderLogoButton}>
        <img
          src="/assets/white-logo.svg"
          alt="Logo"
          className={styles.signInHeaderLogo}
        />
      </button>

      {shouldShowButton && (
        <div className={styles.signInHeaderActions}>
          <Icon name="mypage" onClick={handleMyPage} size={24} />
        </div>
      )}
    </div>
  )
}

export default SignInHeader
